if (!customElements.get('product-card-image-slider')) {
  const MOBILE_MQ = window.matchMedia('(max-width: 767.98px)');

  class ProductCardImageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = this.track ? [...this.track.querySelectorAll('[data-slider-slide]')] : [];
      if (!this.track || this.slides.length === 0) return;

      this.dots = [...this.querySelectorAll('[data-slider-dot]')];
      this.dotsContainer = this.querySelector('[data-slider-dots]');
      this.slideCount = parseInt(this.dataset.slideCount, 10) || this.slides.length;
      this.dotCount = this.dots.length;
      this.productUrl = this.dataset.productUrl || '';
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.didDrag = false;

      this.onScroll = () => this.syncDots();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', this.onScroll, { passive: true });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const dotIndex = parseInt(dot.dataset.dotIndex, 10);
          this.goToDot(dotIndex);
        });
      });

      this.track.addEventListener('pointerdown', (event) => {
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        this.didDrag = false;
      });

      this.track.addEventListener('pointermove', (event) => {
        if (
          Math.abs(event.clientX - this.pointerStartX) > 8 ||
          Math.abs(event.clientY - this.pointerStartY) > 8
        ) {
          this.didDrag = true;
        }
      });

      this.addEventListener('click', (event) => {
        if (!MOBILE_MQ.matches) return;
        if (event.target.closest('[data-slider-dot]')) return;
        if (!this.didDrag && this.productUrl) {
          window.location.href = this.productUrl;
        }
      });

      this.syncDots();
    }

    getActiveIndex() {
      const scrollLeft = this.track.scrollLeft;
      let closest = 0;
      let minDistance = Number.POSITIVE_INFINITY;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closest = index;
        }
      });

      return closest;
    }

    getDotIndexForSlide(slideIndex) {
      if (this.dotCount <= 1) return 0;
      return Math.min(slideIndex, this.dotCount - 1);
    }

    getSlideIndexForDot(dotIndex) {
      return Math.min(dotIndex, this.slideCount - 1);
    }

    syncDots() {
      if (!MOBILE_MQ.matches || this.dotCount === 0) return;

      const activeIndex = this.getActiveIndex();
      const activeDot = this.getDotIndexForSlide(activeIndex);
      const hasExtraImages = this.slideCount > this.dotCount;
      const hasMoreAhead =
        hasExtraImages &&
        activeIndex >= this.dotCount - 1 &&
        activeIndex < this.slideCount - 1;

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeDot);
      });

      if (this.dotsContainer) {
        this.dotsContainer.classList.toggle('has-more-ahead', hasMoreAhead);
      }
    }

    goToDot(dotIndex) {
      const slideIndex = this.getSlideIndexForDot(dotIndex);
      const targetSlide = this.slides[slideIndex];
      if (!targetSlide) return;

      this.track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
    }
  }

  customElements.define('product-card-image-slider', ProductCardImageSlider);
}
